import { apiWrapper } from "@ch/api";
import {
  type Payments,
  type UserSubscriptions,
  UserSubscriptionsControllerService,
} from "@ch/generated";
import useLoading from "@ch/helpers/hooks/useLoading";
import { handleError } from "@ch/helpers/utils/handleError";
import { NotifySuccess } from "@ch/helpers/utils/helpers";

import { useQueryClient } from "@tanstack/react-query";

const useRecordSubscription = () => {
  const handle = useLoading();
  const queryClient = useQueryClient();

  const recordSubscription = async (
    requestBody: {
      paymentData?: Payments | undefined;
    },
    callback?: (val: UserSubscriptions) => void,
  ) => {
    handle.startLoading();
    try {
      const data = await apiWrapper(() =>
        UserSubscriptionsControllerService.userSubscriptionsControllerCreate({
          requestBody,
        }),
      );
      NotifySuccess("Subscription successful");
      handle.stopLoading();

      callback?.(data);
      void queryClient.invalidateQueries({
        queryKey: ["UserSubscriptionsControllerService"],
      });
    } catch (error) {
      handleError(error);
      handle.stopLoading();
    }
  };
  return {
    recordSubscription,
    loading: handle.loading,
  };
};

export default useRecordSubscription;
